import * as React from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgUndrawUpdate = (props) => /* @__PURE__ */ _jsxs("svg", {
	"data-name": "Layer 1",
	xmlns: "http://www.w3.org/2000/svg",
	viewBox: "0 0 612 545",
	...props,
	children: [
		/* @__PURE__ */ _jsx("path", {
			d: "M3.625 505.882c6.972 15.945 22.46 25.703 38.318 33.634q3.321 1.662 6.632 3.228c.015.005.03.016.045.02.107.05.213.1.312.151l1.363.643-.215.132-.67.41.694-.393c.069-.04.142-.078.21-.118 8.004-4.53 16.125-9.33 21.76-16.575 5.843-7.523 8.394-18.447 3.602-26.68a16.784 16.784 0 00-2.23-2.995 18.26 18.26 0 00-1.106-1.099 17.99 17.99 0 00-29.914 9.473c-2.387-9.814 4.719-19.24 11.805-26.438 7.09-7.196 15.184-15.082 15.402-25.184a19.465 19.465 0 00-6.554-14.53 18.08 18.08 0 00-.378-.343 26.254 26.254 0 00-17.917-6.761c-12.285.344-23.208 8.316-30.897 17.907-12.377 15.432-18.188 37.39-10.262 55.518z",
			fill: "#f2f2f2"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M23.535 481.186a44.63 44.63 0 00-3.753 12.393 38.753 38.753 0 00.173 11.522 49.653 49.653 0 009.411 21.548 71.462 71.462 0 0012.577 12.867q3.321 1.662 6.632 3.228c.015.005.03.016.045.02.107.05.213.1.312.151l1.363.643-.215.132-.67.41.694-.393c.069-.04.142-.078.21-.118a39.503 39.503 0 018.07-35.378 39.841 39.841 0 0115.062-10.872 18.26 18.26 0 00-1.106-1.099 41.308 41.308 0 00-6.421 3.452 40.475 40.475 0 00-15.828 19.893 41.381 41.381 0 00-1.488 23.102c-.39-.268-.78-.544-1.159-.818a72.56 72.56 0 01-18.746-18.684 46.192 46.192 0 01-7.662-21.032c-.768-8.226 1.49-16.239 5.339-23.463a96.69 96.69 0 0115.691-21.13 109.868 109.868 0 0120.752-16.941.79.79 0 00.261-1.058.672.672 0 00-.378-.343.585.585 0 00-.5.088c-.937.59-1.865 1.187-2.783 1.802a111.115 111.115 0 00-20.772 18.024 89.455 89.455 0 00-15.11 22.054z",
			fill: "#fff"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M271.693 370.284a25.803 25.803 0 1125.803-25.804 25.832 25.832 0 01-25.803 25.804zm0-49.607a23.803 23.803 0 1023.803 23.803 23.83 23.83 0 00-23.803-23.803z",
			fill: "#6c63ff"
		}),
		/* @__PURE__ */ _jsx("path", {
			"data-name": "Path 395",
			d: "M269.235 353.942a2.572 2.572 0 01-1.547-.514l-.028-.021-5.83-4.46a2.59 2.59 0 113.153-4.11l3.776 2.895 8.921-11.64a2.59 2.59 0 013.63-.48l.002.001-.056.077.057-.077a2.592 2.592 0 01.479 3.631l-10.494 13.685a2.59 2.59 0 01-2.06 1.01z",
			fill: "#6c63ff"
		}),
		/* @__PURE__ */ _jsx("circle", {
			cx: 180.367,
			cy: 190.593,
			r: 24.561,
			fill: "#a0616a"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M171.5 335.925q-.465 0-.933-.04a11.003 11.003 0 01-9.875-13.117 10.301 10.301 0 01.27-1.046l-36.25-42.873a8.545 8.545 0 01-.594-10.184l.065-.08 32.63-32.174a9.432 9.432 0 1113.12 13.553l-23.632 22.466 25.872 41.524a10.47 10.47 0 011.459.18 11.002 11.002 0 01-2.133 21.792zM220.819 532.422l12.26-.001 5.832-47.288-18.094.001.002 47.288z",
			fill: "#a0616a"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M217.692 528.419l24.144-.001a15.386 15.386 0 0115.387 15.386v.5l-39.53.002z",
			fill: "#2f2e41"
		}),
		/* @__PURE__ */ _jsx("path", {
			fill: "#a0616a",
			d: "M98.963 515.471l10.534 6.272 29.205-37.647-15.547-9.256-24.192 40.631z"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M98.324 510.432l20.745 12.352h.001a15.386 15.386 0 015.349 21.092l-.256.43-33.966-20.224zM235.972 515.72h-13.729a4.492 4.492 0 01-4.474-4.025l-13.84-130.097a1.5 1.5 0 00-2.86-.459l-24.967 55.286-44.204 72.08a4.521 4.521 0 01-5.649 1.766l-17.659-7.77a4.501 4.501 0 01-2.05-6.427l40.635-68.041 12.463-57.328c-3.92-24.862 12.884-61.823 13.054-62.195l.083-.18 50.526-20.211.232.284c30.023 36.648 25.137 126.487 16.924 223.193a4.53 4.53 0 01-4.485 4.123z",
			fill: "#2f2e41"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M170.91 314.387l-.215-.453c-.103-.217-10.395-21.924-18.329-45.124a34.22 34.22 0 012.373-27.425 34.594 34.594 0 0122.06-16.963 34.636 34.636 0 0140.202 20.743c6.294 15.737 8.528 30.415 6.64 43.625l-.037.264-.241.116z",
			fill: "#6c63ff"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M257.333 349.604a11.318 11.318 0 01-8.678 4.25 11.307 11.307 0 01-11.458-11.612 10.9 10.9 0 01.18-1.66l-48.364-90.075a9.052 9.052 0 1115.405-9.51l47.247 90.707a11.295 11.295 0 015.668 17.9z",
			fill: "#a0616a"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M210.146 176.72h-39v-17c8.56-3.401 16.937-6.293 22 0a17 17 0 0117 17z",
			fill: "#2f2e41"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M168.987 156.72c-23.315 0-29.84 29.224-29.84 45.71 0 9.195 4.158 12.484 10.692 13.597l2.307-12.308 5.405 12.837c1.836.01 3.764-.026 5.763-.063l1.832-3.774 4.087 3.706c16.367.024 29.595 2.41 29.595-13.994 0-16.487-5.724-45.712-29.84-45.712z",
			fill: "#2f2e41"
		}),
		/* @__PURE__ */ _jsx("circle", {
			cx: 380.496,
			cy: 151,
			r: 8,
			fill: "#ccc"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M585.693 248.284a25.803 25.803 0 1125.803-25.804 25.832 25.832 0 01-25.803 25.804zm0-49.607a23.803 23.803 0 1023.803 23.803 23.83 23.83 0 00-23.803-23.803z",
			fill: "#6c63ff"
		}),
		/* @__PURE__ */ _jsx("path", {
			"data-name": "Path 395",
			d: "M583.235 231.942a2.572 2.572 0 01-1.547-.514l-.028-.021-5.83-4.46a2.59 2.59 0 113.153-4.11l3.776 2.895 8.921-11.64a2.59 2.59 0 013.63-.48l.002.001-.056.077.057-.077a2.592 2.592 0 01.479 3.631l-10.494 13.685a2.59 2.59 0 01-2.06 1.01z",
			fill: "#6c63ff"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M582.496 152h-176a1 1 0 010-2h176a1 1 0 010 2zM582.496 171h-176a1 1 0 010-2h176a1 1 0 010 2zM582.496 190h-176a1 1 0 010-2h176a1 1 0 010 2zM542.496 209h-136a1 1 0 010-2h136a1 1 0 010 2zM541.496 228h-135a1 1 0 010-2h135a1 1 0 010 2z",
			fill: "#3f3d56"
		}),
		/* @__PURE__ */ _jsx("circle", {
			cx: 380.496,
			cy: 8,
			r: 8,
			fill: "#ccc"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M585.693 105.284a25.803 25.803 0 1125.803-25.804 25.832 25.832 0 01-25.803 25.804zm0-49.607a23.803 23.803 0 1023.803 23.803 23.83 23.83 0 00-23.803-23.803z",
			fill: "#6c63ff"
		}),
		/* @__PURE__ */ _jsx("path", {
			"data-name": "Path 395",
			d: "M583.235 88.942a2.572 2.572 0 01-1.547-.514l-.028-.021-5.83-4.46a2.59 2.59 0 113.153-4.11l3.776 2.895 8.921-11.64a2.59 2.59 0 013.63-.48l.002.001-.056.077.057-.077a2.592 2.592 0 01.479 3.631L585.298 87.93a2.59 2.59 0 01-2.06 1.01z",
			fill: "#6c63ff"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M582.496 9h-176a1 1 0 010-2h176a1 1 0 010 2zM582.496 28h-176a1 1 0 010-2h176a1 1 0 010 2zM582.496 47h-176a1 1 0 010-2h176a1 1 0 010 2zM542.496 66h-136a1 1 0 010-2h136a1 1 0 010 2zM541.496 85h-135a1 1 0 010-2h135a1 1 0 010 2z",
			fill: "#3f3d56"
		}),
		/* @__PURE__ */ _jsx("circle", {
			cx: 380.496,
			cy: 293,
			r: 8,
			fill: "#ccc"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M585.693 390.284a25.803 25.803 0 1125.803-25.804 25.832 25.832 0 01-25.803 25.804zm0-49.607a23.803 23.803 0 1023.803 23.803 23.83 23.83 0 00-23.803-23.803z",
			fill: "#e6e6e6"
		}),
		/* @__PURE__ */ _jsx("path", {
			"data-name": "Path 395",
			d: "M583.235 373.942a2.572 2.572 0 01-1.547-.514l-.028-.021-5.83-4.46a2.59 2.59 0 113.153-4.11l3.776 2.895 8.921-11.64a2.59 2.59 0 013.63-.48l.002.001-.056.077.057-.077a2.592 2.592 0 01.479 3.631l-10.494 13.685a2.59 2.59 0 01-2.06 1.01z",
			fill: "#e6e6e6"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M582.496 294h-176a1 1 0 010-2h176a1 1 0 010 2zM582.496 313h-176a1 1 0 010-2h176a1 1 0 010 2zM582.496 332h-176a1 1 0 010-2h176a1 1 0 010 2zM542.496 351h-136a1 1 0 010-2h136a1 1 0 010 2zM541.496 370h-135a1 1 0 010-2h135a1 1 0 010 2zM386.264 545h-381a1 1 0 010-2h381a1 1 0 010 2z",
			fill: "#3f3d56"
		})
	]
});
export default SvgUndrawUpdate;
